export default [
  {
    title: 'guideTitle11',
    text: {
      color: '#000000',
      content: 'guideText11',
    },
    combinations: [],
  },
];
